import axios from "axios";
import { GridColDef } from '@mui/x-data-grid';
import moment from 'moment';
import "i18n/config";
import i18next from "i18next";
import EditTextarea from 'components/EditableGrid/EditTextarea';
export async function get(assessment_id: string) {
    let response = await axios.get(process.env.REACT_APP_WISEVIEW_BACKEND_URL+ "/treatment/assessment/"+assessment_id);
    return response.data;
}

export const update = async (row:any, assessment_id: string) => {
    let response = null;
    if(!row.id) {
        response = await axios.post(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/treatment/assessment/"+assessment_id+"/store",row);
    } else {
        response = await axios.post(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/treatment/update/"+row.id,row);
    }
    return response.data;
};

export const destroy = async (id:any) => {
    let response = null;
    response = await axios.post(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/treatment/delete/"+id);
    return response.data;
};

export async function getIncrements(assessment_id: string, quarter?: string) {
  if(!quarter) quarter="";
  let response = await axios.get(process.env.REACT_APP_WISEVIEW_BACKEND_URL+ "/treatment/assessment/"+assessment_id+"/increments/"+quarter);
  return response.data;
}

export const getCategories = async () => {
  let response = await axios.get(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/treatment/categories");
  return response.data;
};

export async function getColumns(locale: string) {
  i18next.changeLanguage(locale);
  return [
    { 
      field: 'id', 
      headerName: 'ID', 
      width: 10 
    },
    { 
      field: 'treatment_id', 
      headerName: 'TID', 
      width: 80 
    },
    {
      field: 'category',
      headerName: i18next.t('Category'),
      flex: 1,
      minWidth: 150,
      editable: true,
      type: 'singleSelect',
      valueOptions: [],
      valueGetter: params => params.row.category || '',
    },
    {
      field: 'name',
      headerName: i18next.t('Name'),
      flex: 1,
      minWidth: 150,
      editable: true,
    },
    {
      field: 'description',
      headerName: i18next.t('Description'),
      flex: 1,
      minWidth: 200,
      editable: true,
      renderEditCell: (params) => <EditTextarea {...params} />,
    },
    {
      field: 'controls',
      headerName: i18next.t('Used in'),
      flex: 1,
      minWidth: 50,
      valueGetter: params => (params.row.controls?.length || 0) + " controls",
    },
      {
        field: 'note',
        headerName: i18next.t('Note'),
        flex: 1,
        minWidth: 200,
        editable: true,
        renderEditCell: (params) => <EditTextarea {...params} />,
      }
  ] as GridColDef[];
}



